<template>
  <b-form action="">
    <div class="d-flex">
      <b-form-group
        id="input-group-startDate"
        label-for="startDate"
        description="Desde"
        label="Fecha inicio"
        class="m-0"
      >
        <b-form-datepicker
          id="startDate"
          v-model="filtersB.startDate"
          placeholder="Fecha"
          :date-format-options="{
            year: 'numeric', month: 'short', day: '2-digit'
          }"
          locale="es"
          name="startDate"
        ></b-form-datepicker>
      </b-form-group>
      <b-form-group
        id="input-group-endDate"
        label-for="endDate"
        description="Hasta"
        label="Fecha fin"
        class="ml-3"
      >
        <b-form-datepicker
          id="endDate"
          v-model="filtersB.endDate"
          placeholder="Fecha"
          :date-format-options="{
            year: 'numeric', month: 'short', day: '2-digit'
          }"
          locale="es"
          name="endDate"
        ></b-form-datepicker>
      </b-form-group>
      <b-form-group
        id="input-group"
        class="ml-2"
        :label="`\xa0`"
      >
        <b-button type="submit" variant="primary">Buscar</b-button>
      </b-form-group>
    </div>
    </b-form>
</template>
<script>
  export default {
    name:'SearchReservationsCashier',
    props:['filters'],
    data() {
      return {
        filtersB: this.filters
      }
    }
  }
</script>